import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { useSearchParams } from 'marketplace-ui-common/hooks/useSearchParams';
import { SearchResultViewTracker } from 'marketplace-ui-tracking/events/marketplace';
import { StorefrontListingCard } from '../../components/cards/StorefrontListingCard';
import { getProdutTypeByCard, getSourceIdByCard } from '../../utils/usageTracker';
import { useSearchResultsQuery } from '../hooks/useSearchResultsQuery';
import { COLUMN_WIDTH, GAP_TOKEN } from './ResultsGridWithSummary';
import { jsx as _jsx } from "react/jsx-runtime";
export function ResultsGridWithoutSummary() {
  var _data$result$cards, _params$get;
  const {
    data
  } = useSearchResultsQuery();
  const cards = (_data$result$cards = data === null || data === void 0 ? void 0 : data.result.cards) !== null && _data$result$cards !== void 0 ? _data$result$cards : [];
  const params = useSearchParams();
  const pageNumber = parseInt((_params$get = params.get('page')) !== null && _params$get !== void 0 ? _params$get : '1', 10);
  return /*#__PURE__*/_jsx(CardGrid, {
    columnSize: COLUMN_WIDTH,
    gap: GAP_TOKEN
    // prevents a lone card from being too wide
    ,
    maxInlineSize: cards.length === 1 ? `${COLUMN_WIDTH}px` : undefined,
    children: cards.map((card, index) => /*#__PURE__*/_jsx(SearchResultViewTracker, {
      componentType: "EcosystemListingCard",
      installed: Boolean(card.installCount && card.installCount > 0),
      listingId: card.listingId,
      pageNumber: pageNumber,
      resultCount: cards.length,
      resultIndex: index + 1,
      resultType: "LISTING",
      slug: card.slug,
      sourceId: getSourceIdByCard(card),
      subscreen: "search results",
      type: getProdutTypeByCard(card),
      children: /*#__PURE__*/_jsx(StorefrontListingCard, {
        card: card,
        resultCount: cards.length,
        resultIndex: index + 1
      })
    }, card.slug))
  });
}